/** ป้ายสถานะบัญชีล็อกอินและรูปแบบ username — ใช้ร่วมกันระหว่างตารางกับแผงจัดการ */

import type { StatusTone } from '../StatusBadge';
import type { RbacAdminFailure } from '../../lib/rbacAdmin/client';

/** เหมือน `USERNAME_PATTERN` ฝั่ง API — ตรวจก่อนส่งเพื่อบอกผู้ดูแลทันที เซิร์ฟเวอร์ยังตรวจซ้ำ */
export const USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{2,63}$/;

const LOGIN_STATUS: Readonly<Record<string, { label: string; tone: StatusTone }>> = {
  NONE: { label: 'ยังไม่มีบัญชีล็อกอิน', tone: 'neutral' },
  ACTIVE: { label: 'ใช้งานได้', tone: 'success' },
  MUST_CHANGE_PASSWORD: { label: 'รอเปลี่ยนรหัสครั้งแรก', tone: 'warning' },
  LOCKED: { label: 'ถูกล็อก (ใส่รหัสผิดหลายครั้ง)', tone: 'danger' },
  REVOKED: { label: 'ถูกระงับ', tone: 'danger' },
};

export function loginFailureText(failure: RbacAdminFailure): string {
  if ('error' in failure) {
    switch (failure.error.rule) {
      case 'USERNAME_TAKEN':
        return 'username นี้มีคนใช้แล้ว (ไม่สนตัวพิมพ์เล็กใหญ่) เลือกชื่ออื่น';
      case 'CREDENTIAL_EXISTS':
        return 'พนักงานคนนี้มีบัญชีอยู่แล้ว ใช้ปุ่ม "รีเซ็ตรหัสผ่าน" แทน';
      case 'EMPLOYEE_NOT_ACTIVE':
        return 'ออกบัญชีได้เฉพาะพนักงานที่สถานะใช้งานอยู่';
      case 'EMPLOYEE_NOT_FOUND':
        return 'ไม่พบพนักงานคนนี้แล้ว โหลดรายการใหม่';
      default:
        break;
    }
  }
  switch (failure.status) {
    case 'bad-request':
      return 'username ใช้ได้เฉพาะ a-z ตัวเล็ก ตัวเลข และ . _ - ยาว 3–64 ตัว';
    case 'forbidden':
      return 'บัญชีของคุณไม่มีสิทธิ์จัดการบัญชีล็อกอิน (ต้องมี RBAC_ADMIN + EDIT)';
    case 'not-found':
      return 'พนักงานคนนี้ยังไม่มีบัญชีให้รีเซ็ต ใช้ "ออกบัญชีล็อกอิน" แทน';
    case 'unauthenticated':
      return 'session หมดอายุ เข้าสู่ระบบใหม่แล้วลองอีกครั้ง';
    case 'network-error':
      return 'ติดต่อเซิร์ฟเวอร์ไม่ได้ ไม่มีอะไรถูกเปลี่ยน';
    case 'cancelled':
      return 'ยกเลิกคำขอแล้ว';
    default:
      return 'เซิร์ฟเวอร์ตอบไม่สำเร็จ ลองใหม่อีกครั้ง';
  }
}

export function loginStatusOf(status: string | undefined): { label: string; tone: StatusTone } {
  const key = status ?? 'NONE';
  return LOGIN_STATUS[key] ?? { label: key, tone: 'neutral' };
}
